import React, { Component } from 'react';
import OfficeOverheadService from '../../../Services/OfficeOverheadService';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import OfficeOverheadItem from '../../../Domain/OfficeOverheadItem';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import EditOfficeOverheadWindowDescription from './EditOfficeOverheadWindowDescription';

class OfficeOverheadPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listOfOfficeOverheadResult: [],
      OfficeId: props.OfficeId,
      numberOfElementInList: 10,
      searchItem: {},
    };

    OfficeOverheadItem.clickOnEdit = this.showWindow.bind(this);
    OfficeOverheadItem.clickOnRemove = this.clickOnRemoveOfficeOverhead.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  showWindow(itemId) {
    this.setState({
      window: (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={itemId}
          clickOnCancel={() => this.setState({ window: '' })}
          clickOnSave={() => {
            this.setState({ window: '' });
            this.refresh();
          }}
          windowDescription={EditOfficeOverheadWindowDescription}
          errorCode='OFF-OVH-EDIT'
        />
      ),
    });
  }

  clickOnRemoveFromOfficeOverhead(itemId) {
    OfficeOverheadService.RemoveOfficeOverhead(itemId)
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          ErrorMessage.SetNotification('Overhead has been removed.');
        }
        this.refresh();
      })
      .catch(() => ErrorMessage.SetErrorMessage('OOP59'));
  }

  clickOnRemoveOfficeOverhead(itemId) {
    const message = `You will remove this overhead (${itemId.Quarter}). Are you sure?`;
    ErrorMessage.SetApprove(message, () => this.clickOnRemoveFromOfficeOverhead(itemId.OfficeOverheadId));
  }

  AreAllItemsSelected() {
    return this.state.numberOfElementInList === 10;
  }

  ClickOnSelectAllButton() {
    if (this.state.numberOfElementInList === 10) {
      const numberOfElement = this.state.listOfOfficeOverheadResult.length;
      this.setState({ numberOfElementInList: numberOfElement });
    } else {
      this.setState({ numberOfElementInList: 10 });
    }
  }

  renderActionButtonRow() {
    return (
      <FigmaButtonRow
        className={'InnerMenuButtonFigmaList'}
        buttons={[
          {
            iconName: 'fa fa-solid fa-eye',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Secondary,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.ClickOnSelectAllButton(),
            tooltip: this.AreAllItemsSelected() ? 'Show All' : 'Show last 10',
          },
        ]}
      />
    );
  }

  render() {
    let listOfOfficeOverheadResult = this.state.listOfOfficeOverheadResult;

    if (listOfOfficeOverheadResult !== [] && listOfOfficeOverheadResult.length > 0)
      listOfOfficeOverheadResult = [...listOfOfficeOverheadResult]
        .sort((a, b) => b - a)
        .slice(0, this.state.numberOfElementInList);

    return (
      <div>
        {this.state.window}
        {this.renderActionButtonRow()}
        <TabOfDataTable
          type={OfficeOverheadItem}
          itemList={listOfOfficeOverheadResult}
          serviceFunction={() => OfficeOverheadService.GetOfficeOverheadList(this.state.OfficeId)}
          convertDBItemsFunction={OfficeOverheadService.ConvertDBOfficeOverhead}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Asc}
          showSearchStrip={false}
          searchParamsType={null}
          changeOfItemListFunction={(list) => this.setState({ listOfOfficeOverheadResult: list })}
          errorCode='OOP130'
        />
      </div>
    );
  }
}

export default OfficeOverheadPanel;
